import { Link } from "react-router-dom";
import PruloLogo from "@/components/shared/PruloLogo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative z-10 border-t border-white/5 bg-black">
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <PruloLogo height={56} />
            <p className="mt-6 max-w-md text-zinc-400 leading-relaxed">
              The marketing engine behind today's biggest music moments. Built for labels,
              artists, and management teams who want to turn songs into culture.
            </p>
            <div className="mt-8 text-xs uppercase tracking-[0.2em] text-zinc-500">
              Business@prulomedia.com
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Company</div>
            <ul className="space-y-3 text-sm text-zinc-300">
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Platform</div>
            <ul className="space-y-3 text-sm text-zinc-300">
              <li><Link to="/services" className="hover:text-white">Services</Link></li>
              <li><Link to="/case-studies" className="hover:text-white">Case Studies</Link></li>
              <li><Link to="/become-a-creator" className="hover:text-white">Become a Creator</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5">
          <div className="text-xs text-zinc-500">© {new Date().getFullYear()} Prulo Media. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
